<template>
  <div>测试上传npm</div>
</template>

<script>
export default {
  name: "wfl-demo",
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/wfl-demo/demo.vue